module.exports = __webpack_public_path__ + "b49eecf942483497338b52645ff3f347.pdf";